import { useAuthStore } from '@/store/authStore';
import { authApi } from '@/api/auth';

export function useAuth() {
  const { user, isAuthenticated, setAuth, logout } = useAuthStore();

  async function login(identifier: string, password: string) {
    const { data } = await authApi.login(identifier, password);
    // Set tokens first so the interceptor can attach them to the next request
    setAuth(data.data.user, data.data.accessToken, data.data.refreshToken);
    // Fetch the full user with relations (student, parent, cafeteria)
    const meRes = await authApi.me();
    setAuth(meRes.data.data, data.data.accessToken, data.data.refreshToken);
    return meRes.data.data;
  }

  async function registerParent(data: { firstName: string; lastName: string; email: string; password: string; studentCode: string }) {
    const { data: res } = await authApi.registerParent(data);
    setAuth(res.data.user, res.data.accessToken, res.data.refreshToken);
    const meRes = await authApi.me();
    setAuth(meRes.data.data, res.data.accessToken, res.data.refreshToken);
    return meRes.data.data;
  }

  async function signOut() {
    const refreshToken = useAuthStore.getState().refreshToken;
    if (refreshToken) {
      await authApi.logout(refreshToken).catch(() => null);
    }
    logout();
  }

  return { user, isAuthenticated, login, registerParent, logout: signOut };
}
